
function DigitalStory() {
  return (
    <section className="my-20">
      <div className="container">
        <div className="flex justify-center">
          <div className="w-full lg:w-11/12">
          <div className="cont pb-12 md:pt-16 border-gray-200">
              <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12">
                <div className="md:col-span-3 mb-8 md:mb-0">
                  <h6 className="text-xl md:text-2xl lg:text-3xl font-semibold text-gray-800">At GCAD</h6>
                </div>
                <div className="md:col-span-9">
                  <div className="text">
                    <p className="text-gray-600 leading-relaxed md:leading-loose text-base md:text-lg">
                    What connects all products is intent. They are purpose-driven, carefully engineered, and built to evolve. Behind every interface is structured thinking. Behind every system is a clear architecture. And behind every release is a commitment to reliability, scalability, and long-term value.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default DigitalStory;
